import { render } from "./update-dialog.vue?vue&type=template&id=acf040fe&scoped=true"
import script from "./update-dialog.vue?vue&type=script&lang=js"
export * from "./update-dialog.vue?vue&type=script&lang=js"

import "./update-dialog.vue?vue&type=style&index=0&id=acf040fe&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf040fe"]])

export default __exports__